import styled from '@emotion/styled';
import { withConfig } from 'src/withConfig';

export const MatchLeadContainer = withConfig(theme => styled('div', { label: 'MatchLeadContainer' })`
    background-color: ${theme.star.stream.bgColor};
`);
